<template>
  <el-dialog class="red-packet" :visible.sync="show" :close-on-click-modal="false" :show-close="false" @open="open">
    <div class="lottery-box">
      <h3 v-if="!ifRefund">
        恭喜您获得<span class="count">{{ lotteryNumber }}</span
        >次
      </h3>
      <h3 v-else>
        您还有<span class="count">{{ lotteryNumber }}</span
        >次
      </h3>
      <h3>抽奖机会</h3>
      <div class="qrcode-box">
        <div class="qrcode"></div>
      </div>
      <p class="qrcode-tip">微信扫码参与抽奖</p>
    </div>
    <div class="close-box">
      <img :src="iconClose" @click="show = false" />
    </div>
  </el-dialog>
</template>
<script type="text/javascript">
import QRCode from 'qrcodejs2'
import { getStorage } from '@/lib/utils.js'
import iconClose from '@/assets/images/activity/lottery/icon-close.png'
/* eslint-disable */
export default {
  name: 'RedPacket',
  data() {
    return {
      iconClose,
      show: this.value,
      hasInitQrcode: false
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activityId: {
      default: null
    },
    lotteryNumber: {
      type: Number,
      default: 3
    },
    ifRefund: {
      default: false
    }
  },
  watch: {
    value(val) {
      this.show = val
    },
    show(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    open() {
      this.initQrcode()
    },
    initQrcode() {
      if (this.hasInitQrcode) return
      setTimeout(() => {
        let code = new QRCode(document.getElementsByClassName('qrcode')[0], {
          width: 175,
          height: 175,
          colorDark: '#333',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
          text: `${getStorage('domain', 'sessionStorage').mallMobileweb}/activity/lotteryDetail/${this.activityId}`
        })
      }, 0)
      this.hasInitQrcode = true
    }
  },
  mounted() {
    if (this.show) {
      this.initQrcode()
    }
  }
}
</script>

<style lang="scss" scoped>
.red-packet ::v-deep {
  * {
    box-sizing: border-box;
  }
  .el-dialog {
    background-color: transparent;
    box-shadow: none;
  }
  .el-dialog__header {
    display: none;
  }
  .lottery-box {
    width: 447px;
    height: 464px;
    background-image: url('../../../assets/images/activity/lottery/lottery-bg.png');
    background-size: contain;
    padding-top: 57px;
    text-align: center;
    margin: 0 auto;
    h3 {
      font-size: 30px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(134, 52, 2, 1);
      line-height: 39px;
      .count {
        color: #da0606;
      }
    }
    .qrcode-box {
      margin: 60px auto 0;
      width: 200px;
      height: 200px;
      background: linear-gradient(180deg, rgba(251, 234, 181, 1) 0%, rgba(246, 208, 126, 1) 100%);
      padding-top: 8px;
    }
    .qrcode-tip {
      margin-top: 14px;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 25px;
    }
    .qrcode {
      width: 185px;
      height: 185px;
      margin: 0 auto;
      padding: 5px;
      background-color: #ffffff;
    }
  }
  .close-box {
    margin-top: 25px;
    text-align: center;
    img {
      width: 42px;
      height: 42px;
    }
  }
}
</style>
